import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

interface FieldHelpIconProps {
  title: string;
  /** Optional richer content shown in the tooltip */
  example?: string;
  tip?: string;
}

/**
 * Compact "?" control next to a field label. Hover/click to read field guidance.
 */
const FieldHelpIcon: React.FC<FieldHelpIconProps> = ({ title, example, tip }) => {
  const parts = [title];
  if (example) parts.push(`Example: ${example}`);
  if (tip) parts.push(`Tip: ${tip}`);
  const content = parts.join('\n\n');

  return (
    <Tooltip
      title={<span style={{ whiteSpace: 'pre-line' }}>{content}</span>}
      arrow
      placement="top"
      enterTouchDelay={0}
    >
      <IconButton
        size="small"
        aria-label="Field help"
        onClick={(e) => e.preventDefault()}
        onMouseDown={(e) => e.preventDefault()}
        sx={{
          p: 0.25,
          ml: 0.25,
          color: 'text.secondary',
          '&:hover': { color: 'primary.main', bgcolor: 'action.hover' },
        }}
      >
        <HelpOutlineIcon sx={{ fontSize: 16 }} />
      </IconButton>
    </Tooltip>
  );
};

export default FieldHelpIcon;
